/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { AccessNFT, AccessNFTInterface } from "../AccessNFT";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "redeemer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "nftTokenId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "accessNftId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "AccessNFTRedeemed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "nftIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "nftURIs",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "acessNftIds",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "string[]",
        name: "accessNftURIs",
        type: "string[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "nftSupplies",
        type: "uint256[]",
      },
    ],
    name: "AccessNFTsCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "isTransferable",
        type: "bool",
      },
    ],
    name: "AccessTransferabilityUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "accessNftId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lastTimeToRedeem",
        type: "uint256",
      },
    ],
    name: "LastRedeemTimeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "prevOwner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "NewOwner",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "transferable",
        type: "bool",
      },
    ],
    name: "RestrictedTransferUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "royaltyBps",
        type: "uint256",
      },
    ],
    name: "RoyaltyUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "_contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "accessNftIsTransferable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "string[]",
        name: "_nftURIs",
        type: "string[]",
      },
      {
        internalType: "string[]",
        name: "_accessNftURIs",
        type: "string[]",
      },
      {
        internalType: "uint256[]",
        name: "_nftSupplies",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "createAccessTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256",
      },
    ],
    name: "isRedeemable",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "lastTimeToRedeem",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nextTokenId",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "redeemToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "royaltyBps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "salePrice",
        type: "uint256",
      },
    ],
    name: "royaltyInfo",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "royaltyAmount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_isTransferable",
        type: "bool",
      },
    ],
    name: "setAccessNftTransferability",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_secondsUntilRedeem",
        type: "uint256",
      },
    ],
    name: "setLastTimeToRedeem",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_restrictedTransfer",
        type: "bool",
      },
    ],
    name: "setRestrictedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_royaltyBps",
        type: "uint256",
      },
    ],
    name: "setRoyaltyBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenState",
    outputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
      {
        internalType: "bool",
        name: "isRedeemable",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "accessNftId",
        type: "uint256",
      },
      {
        internalType: "enum AccessNFT.UnderlyingType",
        name: "underlyingType",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "transfersRestricted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_nftId",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type AccessNFTConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AccessNFTConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AccessNFT__factory extends ContractFactory {
  constructor(...args: AccessNFTConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenter: string,
    _trustedForwarder: string,
    _uri: string,
    _royaltyBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<AccessNFT> {
    return super.deploy(
      _controlCenter,
      _trustedForwarder,
      _uri,
      _royaltyBps,
      overrides || {}
    ) as Promise<AccessNFT>;
  }
  getDeployTransaction(
    _controlCenter: string,
    _trustedForwarder: string,
    _uri: string,
    _royaltyBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controlCenter,
      _trustedForwarder,
      _uri,
      _royaltyBps,
      overrides || {}
    );
  }
  attach(address: string): AccessNFT {
    return super.attach(address) as AccessNFT;
  }
  connect(signer: Signer): AccessNFT__factory {
    return super.connect(signer) as AccessNFT__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AccessNFTInterface {
    return new utils.Interface(_abi) as AccessNFTInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AccessNFT {
    return new Contract(address, _abi, signerOrProvider) as AccessNFT;
  }
}
